import { wikiTextLegacyEditorInit } from 'Guide/WikiPages/wiki_edit';
import { tween } from 'shifty';
import { createRoot } from 'react-dom/client';
import { Initializer } from 'Shared/chakra-initialize';
import { TiptapEditor } from './tiptap/tiptap';
import { getFormParent } from './utils';

function applyOffset() {
   // Scroll to desired section if applicable
   const offset = getURLParameter('offset');
   if (offset) {
      const headers = document.getElementsByTagName('h2');
      if (headers.length > offset) {
         const desiredSection = headers[offset];
         const desiredSectionY = desiredSection.getBoundingClientRect().top;
         scrollToSection(desiredSectionY);
      }
   }
}

function scrollToSection(sectionY) {
   tween({
      from: { y: 0 },
      to: { y: sectionY - 30 },
      duration: 750,
      easing: 'easeInOutQuad',
      render: state => window.scrollTo(0, state.y),
   });
}

const getSubmitHandler = pm => {
   const form = getFormParent(pm);
   return () => {
      const formManager = form.retrieve('FormManager:formManager');
      formManager.submit();
   };
};

function getOrCreateTiptap(pm) {
   const editorid = 'wikiTextField';

   const EditorComponent = Initializer(TiptapEditor);

   const root = createRoot(pm);
   root.render(
      <EditorComponent
         editorid={editorid}
         preset="wiki"
         text={pm.dataset['text']}
         submitHandler={getSubmitHandler(pm)}
         onEditorReady={() => applyOffset()}
      />
   );

   return editorid;
}

onDomReady(() => {
   if (!document.querySelector('#wikiTextField')) {
      return;
   }

   const prosemirror = document.querySelector('.prosemirror');

   if (!prosemirror) {
      wikiTextLegacyEditorInit();
      return;
   }

   return getOrCreateTiptap(prosemirror);
});
